import { TOP_MATCHES } from '../config';

type MatchEntity = { id: number; match: { value: number } };

export const buildCircles = <T extends MatchEntity>(
  items: T[],
  getLabel: (item: T) => string,
): Matches.Circle[] =>
    items
      .slice(0, TOP_MATCHES)
      .map(item => ({ id: item.id, label: getLabel(item), matchValue: item.match?.value ?? 0 }));

export const buildPlotted = (
  circles: Matches.Circle[],
  assertions: Assertions.Assertion[],
  getLinks: (assertion: Assertions.Assertion) => Assertions.LinkedEntity[],
): Matches.PlottedAssertion[] => {
  return assertions
    .map(assertion => ({ assertion, linkIds: getLinks(assertion).map(link => link.id) }))
    .filter(({ assertion, linkIds }) => linkIds.length > 0 && !!assertion.userAnswer)
    .sort((a, b) => a.assertion.id - b.assertion.id)
    .map(({ assertion, linkIds }, index) => ({
      id: assertion.id,
      number: index + 1,
      content: assertion.content,
      answer: assertion.userAnswer as Assertions.AnswerValue,
      setIndexes: circles
        .map((circle, circleIndex) => (linkIds.includes(circle.id) ? circleIndex : -1))
        .filter(circleIndex => circleIndex >= 0),
    }));
};
